import { Euler, Object3D, Vector3 } from "three";

/**
 * This is a helper function to set the position of a directional light
 * based on altitude and azimuth parameters, which may be more intuitive
 * than a 3D position. Altitude is the angle between the horizon and the
 * zenith, ranging between 0 and PI/2. Azimuth is the compass heading of the
 * light source, ranging from 0 to 2*PI, where 0 is East, PI/2 is North,
 * etc. In three.js the ground plane is XZ, so +Z is North, +X is East, etc.
 */
export const directionalPosition = (light: Object3D, alt: number, az: number) => {
    var euler = new Euler(0.0, az, alt, 'XYZ');
    // the initial position is arbitrary since the light rays are parallel
    light.position.x = 200;
    light.position.y = 0;
    light.position.z = 0;
    light.position.applyEuler(euler);
}
export default directionalPosition;

const e = new Euler();

/**
 * This is a more complex/flexible version of directionalPosition.
 *
 * @param obj - the position of the object to move
 * @param center - the origin around which to interpret the altitude and azimuth
 * @param alt - the altitude (see directionalPosition documentation)
 * @param az - the azimuth (see directionalPosition documentation)
 * @param r - the distance of the object from the center
 */
export const relativeDirectionalPosition =
    (obj: Vector3, center: Vector3, alt: number, az: number, r: number) =>
{
    // Place the vector on the x axis at distance `r`
    obj.set(r, 0, 0);

    e.set(0, az, alt);
    obj.applyEuler(e);

    obj.add(center);
}
